import Grid from "@mui/material/Grid/Grid";
import {CustomLabelMediumBold, CustomLabelMediumRegular, CustomLabelSmallRegular} from "../common/CustomLabel"; 
import React from "react";
// import {motion} from 'framer-motion';
import AUTOMOTIVE from '../../assets/icons/Automotive.png';
import CONSTRUCTION from '../../assets/icons/Construction.png';
import ECOMMERCE from '../../assets/icons/Ecommerce.png';
import EDUCATION from '../../assets/icons/Education.png';
import ENERGY_UTILITIES from '../../assets/icons/EnergyUtilities.png';
import ENTERTAINMENT from '../../assets/icons/Entertainment.png';
import FINANCE from '../../assets/icons/Finance.png';
import FOOD_BEVERAGES from '../../assets/icons/FoodBeverages.png';
import GOVERNMENT_SECTOR from '../../assets/icons/GovernmentSector.png';
import HOSPITALITY from '../../assets/icons/Hospitality.png';
import MANUFACTURING from '../../assets/icons/Manufacturing.png';
import MEDIA_PUBLISHING from '../../assets/icons/MediaPublishing.png';
import PUBLIC_SECTOR from '../../assets/icons/PublicSector.png';
import REAL_ESTATE from '../../assets/icons/RealEstate.png';
import RETAIL from '../../assets/icons/Retail.png';
import TRANSPORTATION from '../../assets/icons/Transportation.png';
import TRAVEL_TOURISM from '../../assets/icons/TravelTourism.png';
import Box from "@mui/material/Box";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const industryData = [
    { icon: ENTERTAINMENT, text: "Entertainment" },
    { icon: MEDIA_PUBLISHING, text: "Media & Publishing" },
    { icon: TRANSPORTATION, text: "Transportation" },
    { icon: AUTOMOTIVE, text: "Automotive" },
    { icon: TRAVEL_TOURISM, text: "Travel & Tourism" },
    { icon: RETAIL, text: "Retail" },
    { icon: ECOMMERCE, text: "Ecommerce" },
    { icon: EDUCATION, text: "Education" },
    { icon: FINANCE, text: "Finance" },
    { icon: HOSPITALITY, text: "Hospitality" },
    { icon: REAL_ESTATE, text: "Real Estate" },
    { icon: FOOD_BEVERAGES, text: "Food & Beverages" },
    { icon: ENERGY_UTILITIES, text: "Energy & Utilities" },
    { icon: CONSTRUCTION, text: "Construction" },
    { icon: MANUFACTURING, text: "Manufacturing" },
    { icon: GOVERNMENT_SECTOR, text: "Government Sector" },
    { icon: PUBLIC_SECTOR, text: "Public Sector" }
];

// Split data into rows
// const rows = [
//     industryData.slice(0, 8),
//     industryData.slice(8, 16)
// ];

const ImpactAcrossIndustries = ({partnersRef}) => {
    // Settings for alternate direction sliders
    const settingsForward = {
        dots: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 3000,
        autoplaySpeed: 0,
        cssEase: "linear",
        pauseOnHover: true,
        swipeToSlide: true,
        draggable: true,
        touchThreshold: 10,
        rtl: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };

    const settingsReverse = {
        ...settingsForward,
        rtl: true  // Reverse direction
    };

    return (
        <Grid container sx={{ paddingBottom: { xs: "30px", md: "50px" } }} justifyContent={"center"}>
            <Grid item container my={2} justifyContent={"center"} sx={{marginTop: {xs: "30px", md: "50px"}, textAlign: "center"}}>
                <CustomLabelMediumBold text={"BEYOND ONE INDUSTRY, BEYOND ONE SOLUTION"} fontWeight={700} color={"#5E17EB"}/>
            </Grid>

            <div ref={partnersRef} tabIndex={0}></div>

            <Grid item container my={8} xs={10} sx={{marginTop: {xs: "2px", md: "5px"}}} justifyContent={"center"}>
                <CustomLabelMediumRegular 
                    normal={false}
                    text={<>As a 
                    &nbsp;<a href="https://ostryx.com" target="_blank" rel="noopener noreferrer" style={{color: "#5E17EB"}}><b>Leading Mobile App Development Company</b></a> 
                    &nbsp;we build solutions that industries rely on, no matter the market or mission.</>}
                />
            </Grid>

            {/* First Row */}
            <Grid item xs={12} sx={{ 
                // padding: {xs: "0px 5px", md: "0px 30px"}, 
                marginY: 2,
                '& .slick-track': {
                    display: 'flex',
                    alignItems: 'center'
                },
                '& .slick-slide': {
                    cursor: 'grab',
                    '&:active': {
                        cursor: 'grabbing'
                    }
                }
            }}>
                <Slider {...settingsForward}>
                    {[...industryData.slice(0, 8), ...industryData.slice(0, 8)].map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                px: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Box
                                sx={{
                                    background: "#FAF7FF",
                                    padding: { xs: "8px 12px", md: "12px 15px" },
                                    borderRadius: "15px",
                                    border: "1px solid #F5F5F5",
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.icon}
                                    alt={item.text}
                                    sx={{
                                        width: { xs: "20px", md: "25px" },
                                        height: { xs: "20px", md: "25px" }
                                    }}
                                />
                                <CustomLabelSmallRegular text={item.text} />
                            </Box>
                        </Box>
                    ))}
                </Slider>
            </Grid>

            {/* Second Row */}
            <Grid item xs={12} sx={{ 
                // padding: {xs: "0px 5px", md: "0px 30px"}, 
                marginY: 2,
                '& .slick-track': {
                    display: 'flex',
                    alignItems: 'center'
                },
                '& .slick-slide': {
                    cursor: 'grab',
                    '&:active': {
                        cursor: 'grabbing'
                    }
                }
            }}>
                <Slider {...settingsReverse}>
                    {[...industryData.slice(8, 16), ...industryData.slice(8, 16)].map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                px: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Box
                                sx={{
                                    background: "#FAF7FF",
                                    padding: { xs: "8px 12px", md: "12px 15px" },
                                    borderRadius: "15px",
                                    border: "1px solid #F5F5F5",
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.icon}
                                    alt={item.text}
                                    sx={{
                                        width: { xs: "20px", md: "25px" },
                                        height: { xs: "20px", md: "25px" }
                                    }}
                                />
                                <CustomLabelSmallRegular text={item.text} />
                            </Box>
                        </Box>
                    ))}
                </Slider>
            </Grid>
        </Grid>
    );
};

export default ImpactAcrossIndustries;
